<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Deployment Process</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Deployment</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="w-100" src="assets/img/service/sv-details.jpg" alt="Deployment Process" />
                    </div>
                    <div class="page-content sv-content d-block">
                        <h2 class="box-title">Deployment Process</h2>
                        <p class="box-text mb-30">The deployment process in web application development involves the
                            steps required to make the application available and accessible to end-users in a production
                            environment. It includes setting up the necessary infrastructure, configuring servers,
                            transferring files, and ensuring the application runs smoothly.
                        </p>
                        <div class="sv-gallery-wrapper">
                            <h2 class="box-title">Why Web Deployment Important?</h2>
                            <p>Here are the key steps involved in the deployment process:</p>
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/video-image-1.jpg.webp" alt="" />
                                    </div>
                                </div>
                                <div class="col-6 my-5">
                                    <div class="checklist tick-checklist sv-details-list mb-40">
                                        <ul class="list">
                                            <li>Environment Setup &amp; Configuration Management</li>
                                            <li>Code Compilation and Packaging</li>
                                            <li>File Transfer &amp; Database Migration</li>
                                            <li>Server Configuration</li>
                                            <li>Application Deployment &amp; Testing and Quality Assurance</li>
                                            <li>Monitoring and Logging</li>
                                            <li>Final Checks and Validation</li>
                                            <li>Rollout and Release</li>
                                            <li>Post-Deployment Support</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row gy-4">
                                <div class="col-12">
                                    <p>The deployment process requires collaboration between developers, system
                                        administrators, and operations teams to ensure a smooth and successful release
                                        of the web application. By following a structured deployment process, teams can
                                        ensure the application is available to users in a reliable and efficient manner.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-service-sidebar></app-service-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>